module.exports = __webpack_public_path__ + "static/media/other-viola.9b6cc844.mp3";